<template>
	<div class="category-analysis">
		<div class="page-title">
			<span class="title">品类分析</span>
			<a-row class="description" type="flex" justify="space-between">
				<div>
					<a-checkable-tag :checked="mediaType === 'META'" @change="mediaChange('META')">Meta</a-checkable-tag>
					<a-checkable-tag :checked="mediaType === 'GOOGLE'" @change="mediaChange('GOOGLE')">Google</a-checkable-tag>
				</div>
				<span>说明：以下数据来源于YM投放的效果数据汇总，仅做参考</span>
			</a-row>
		</div>
		<div class="analysis-tabs">
			<a-tabs v-model="activeKey" type="card">
				<a-tab-pane key="categoryRank" tab="品类排行"></a-tab-pane>
				<a-tab-pane key="categoryTrend" tab="品类趋势"></a-tab-pane>
				<a-tab-pane key="countryRank" tab="国家&amp;地区排行" v-if="mediaType === 'META'"></a-tab-pane>
				<a-tab-pane key="countryTrend" tab="国家&amp;地区趋势" v-if="mediaType === 'META'"></a-tab-pane>
			</a-tabs>
		</div>
		<component :mediaType="mediaType" :is="activeKey" ref="com"></component>
	</div>
</template>
<script>
import countryRank from './components/countryRank'
import categoryRank from './components/categoryRank'
import countryTrend from './components/countryTrend'
import categoryTrend from './components/categoryTrend'


export default {
	name: 'CategoryAnalysis',
	data() {
		return {
			activeKey: 'categoryRank',
			mediaType: 'META'
		}
	},
	methods: {
		mediaChange(type) {
			if(this.mediaType !== type) {
				this.mediaType = type
				if(this.activeKey !== 'categoryRank'&&this.activeKey !== 'categoryTrend') {
					this.activeKey = 'categoryRank'
					return
				}
				this.$nextTick(() => {
					this.$refs.com.country = 'ALL'
					this.$refs.com.getList()
				})
			}
		}
	},
	mounted() {
	},
	components: {
		countryRank,
		categoryRank,
		categoryTrend,
		countryTrend
	}
}
</script>
<style lang="less">
.category-analysis {
	.page-title {
		position: relative;
		.title {
			position: absolute;
			left: 24px;
		}
		.description {
			font-size: 12px;
			font-weight: 400;
			color: #677392;
			line-height: 20px;
			vertical-align: bottom;
			padding-left: 100px;
			padding-right: 12px;
			padding-top: 8px;
			.ant-tag-checkable {
				background-color: transparent;
    		border-color: transparent;
				border-radius: 4px 4px 4px 4px;
				line-height: 20px;
				font-weight: 500;
				cursor: pointer;
				&:hover {
					color: #4278FF!important;
				}
				&.ant-tag-checkable-checked {
					background: #F3F7FF;
					font-size: 12px;
					color: #4278FF!important;
				}
			}
		}
	}
	.analysis-tabs {
		padding: 0 24px;
	}
	.filter-box {
		margin: 0 24px;
		background: #FBFCFE;
		border-radius: 8px;
		padding: 16px 24px;
		.input-search {
			width: 320px;
			margin-bottom: 4px;
		}
		.tag-box {
			.title {
				font-size: 12px;
				font-weight: 500;
				color: #677392;
				line-height: 30px;
				margin-right: 12px;
			}
			.ant-tag {
				line-height: 30px;
				margin-top: 12px;
			}
		}
	}
	.chart-box {
		margin: 24px 24px 0;
	}
}
</style>